import { ROLES } from 'src/infra/Api/PER/roles.peru'

export const getPeruRoles = () => ROLES
